<template>
  <div class="padding">
    <h2>404</h2>
    <div>
      <router-link to="/">
        <el-button type=primary>Go home</el-button>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/routes/Error404.vue